import './style.scss'

const DESKTOP_BREAKPOINT = 1024

const ready = () => {
  // cache clickable headings
  const headings = Array.prototype.slice.call(document.querySelectorAll('.wz-footer-list-heading'))

  const findFooterList = node => {
    while (node && !node.classList.contains('wz-footer-list-heading')) {
      node = node.parentNode
    }
    return node
  }

  // define click handler
  const handler = event => {
    event.preventDefault()

    const target = findFooterList(event.target)

    // if desktop, do nothing
    if (window.innerWidth >= DESKTOP_BREAKPOINT) return

    // get parent list
    const list = target.parentNode

    // get parent list content height
    const height = Number.parseInt(list.getAttribute('data-height'), 10)

    // request an animation frame
    window.requestAnimationFrame(() => {
      // set height of list
      // based on current expanded or collapsed state
      list.classList.contains('is-active')
        ? list.removeAttribute('style')
        : (list.style.height = `${height}px`)

      // toggle active class on list
      list.classList.toggle('is-active')
    })
  }

  // bind click handlers
  headings.forEach(node => node.addEventListener('click', handler))
}

export function initialize() {
  ready()
}
